<mat-accordion multi="true">
  <mat-expansion-panel [expanded]="!siteUtilityTitle">
    <mat-expansion-panel-header class="flex items-center" (click)="siteUtilityTitle = !siteUtilityTitle">
      <mat-panel-title>
        <h2>Utility</h2>
      </mat-panel-title>
      <mat-icon *ngIf="isTariffPanelEnabled" matTooltip="Utility not saved" color="warn" style="margin-right: 1rem">error</mat-icon>
      <mat-icon *ngIf="!isTariffPanelEnabled" matTooltip="Utility Saved" color="primary" style="margin-right: 1rem">check_circle</mat-icon>
    </mat-expansion-panel-header>
    <div *ngIf="utility" style="margin-bottom: 1rem">{{ utility?.name }}</div>
    <app-site-utilities [site]="site" (isUtilityFormDirty)="toggleTariffPanel($event)" [(utility)]="utility" [(siteTariffs)]="siteTariffs"></app-site-utilities>
  </mat-expansion-panel>

  <mat-expansion-panel [disabled]="isTariffPanelEnabled || !utility?.id" [expanded]="!siteTariffsTitle">
    <mat-expansion-panel-header (click)="siteTariffsTitle = !siteTariffsTitle">
      <mat-panel-title>
        <h2>Tariffs</h2>
      </mat-panel-title>
      <mat-icon style="margin-right: 1rem" *ngIf="!utility?.id" color="primary" matTooltip="Assign utility first, so tariffs can be retrieved.">info</mat-icon>
      <mat-icon style="margin-right: 1rem" color="warn" *ngIf="(isTariffFormDirty && utility?.id)" matTooltip="Unsaved Tariffs">error</mat-icon>
      <mat-icon  style="margin-right: 1rem"color="primary"  *ngIf="(!isTariffFormDirty && utility?.id) && siteTariffs?.deliveryAfter != null" matTooltip="Tariffs Saved">check_circle</mat-icon>
    </mat-expansion-panel-header>
    <div style="margin-left: 2rem" *ngIf="tariffNames">{{ getTariffsTitle() }}</div>
    <app-tariffs [site]="site" [(siteTariffs)]="siteTariffs" [utility]="utility?.shortName" [isDisabled]="isTariffPanelEnabled" (isTariffFormDirty)="setDirtyTariffForm($event)"></app-tariffs>
  </mat-expansion-panel>

  <mat-expansion-panel [expanded]="!siteChargesTitle">
    <mat-expansion-panel-header (click)="siteChargesTitle = !siteChargesTitle">
      <mat-panel-title>
        <h2>Other Charges</h2>
      </mat-panel-title>
      <mat-icon style="margin-right: 1rem" color="warn" *ngIf="isChargesFormDirty" matTooltip="Unsaved Charges">error</mat-icon>
      <mat-icon style="margin-right: 1rem" color="primary" *ngIf="!isChargesFormDirty" matTooltip="Charges Saved">check_circle</mat-icon>
    </mat-expansion-panel-header>
    <div *ngIf="charges" style="margin-bottom: 1rem">{{ chargesStr }}</div>
    <app-site-charges [site]="site" [(charges)]="charges" (chargesFormDirty)="setDirtyChargesForm($event)"></app-site-charges>
  </mat-expansion-panel>

  <mat-expansion-panel [expanded]="!siteGridTitle">
    <mat-expansion-panel-header (click)="siteGridTitle = !siteGridTitle">
      <mat-panel-title>
        <h2>Grid Services ({{ demandResponsePrograms?.length }})</h2>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <app-site-programs [site]="site" [programs]="demandResponsePrograms"></app-site-programs>
  </mat-expansion-panel>

  <mat-expansion-panel [expanded]="!sitePeakTitle">
    <mat-expansion-panel-header (click)="sitePeakTitle = !sitePeakTitle">
      <mat-panel-title>
        <h2>Coincident Peak ({{ coincidentPeakPrograms?.length }})</h2>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <app-site-programs [site]="site" [programs]="coincidentPeakPrograms"></app-site-programs>
  </mat-expansion-panel>
</mat-accordion>
